<template>
  <div>
    <v-container>
      <div>
        <div style="margin-bottom: 10px">
          <a v-if="!isShow" href="javascript:void(0);" @click="addCommentToInbox">
            <div class="add-conversation text-xs-center">
              <em class="fa fa-plus middle" />
              {{ $t('Add Conversation') }}
            </div>
          </a>

          <div v-else class="intent-item z-border-red" style="padding: 10px 15px 0px">
            <manage-intent
              v-model="intent"
              :is-live-stream="true"
              :is-comment-to-inbox="true"
              :type="'add'"
              :excluded-intent-name="excludedIntentName"
              @close="onClose"
              @saveIntent="onSaveIntent"
            ></manage-intent>
          </div>
        </div>
        <transition-group
          :css="false"
          @before-enter="beforeEnter"
          @enter="enter"
          @leave="leave"
        >
          <intent-item
            v-for="(item, index) in filterIntents"
            :key="'intent_' + item.id + '_' + index"
            v-model="filterIntents[index]"
            :is-live-stream="true"
            :is-comment-to-inbox="true"
            :filter-intents="filterIntents"
            :excluded-intent-name="excludedIntentName"
            @onDelete="deleteIntent(index)"
            @onCopyIntent="copyIntent"
            @onUpdate="onUpdateIntent"
          ></intent-item>
        </transition-group>
      </div>
    </v-container>
    <v-divider></v-divider>

    <v-container>
      <h3 class="headline">{{ $t('More Live Comment') }}</h3>
      <transition name="fade">
        <div v-if="default_live" class="col s12">
          <intent-item
            v-model="default_live"
            :is-live-stream="true"
            :is-comment-to-inbox="true"
            :is-default="true"
            :excluded-intent-name="excludedIntentName"
            @onDelete="deleteIntent(index)"
            @onUpdate="onUpdateIntent"
          ></intent-item>
        </div>
      </transition>
    </v-container>
    <div class="mt-5 mb-5"></div>
  </div>
</template>

<script>
import Velocity from 'velocity-animate'
import TransferIntent from '@/components/view/intent/TransferIntent'
import { mapGetters } from 'vuex'
import manageIntent from '@/components/view/intent/intent-manage'
import intentItem from '@/components/view/intent/intent-item'
import api from '@/api'
import ModalDialog from '@/components/elements/ModalDialog'
import ModalHelp from '@/components/elements/ModalHelp'

import intentApi from '@/api/intent.js'
import { handleResponse, handleApiError } from '@/api/util'

export default {
  components: {
    'manage-intent': manageIntent,
    'intent-item': intentItem,
    ModalDialog,
    ModalHelp,
    TransferIntent
  },
  data() {
    return {
      isShow: false,
      showModal: false,

      intent: {
        intentname: '',
        q_type: 'text',
        a_type: 'json',
        q_val: '',
        a_val: '',
        context_in: '',
        context_out: '',
        pageidlist: '',
        userstatus: '',
        usertags: '',
        linenoti_status: false,
        linenoti_text: null,
        starttime: null,
        endtime: null,
        intentstatus: true
      },
      allIntents: [],
      intents: [],
      search: '',
      welcome_message: {
        message: '',
        generics: [],
        type: '',
        quick_reply: []
      },
      isSave: false,
      lastedIntentName: '',
      default_live: undefined
    }
  },
  computed: {
    ...mapGetters({
      selectedBot: 'selectedBot'
    }),
    filterIntents: function () {
      var vm = this
      vm.intents.sort(function (a, b) {
        var nameA = a.intentname.toUpperCase() // ignore upper and lowercase
        var nameB = b.intentname.toUpperCase() // ignore upper and lowercase
        if (a.intentname[0] === '{' && a.intentname[a.intentname.length - 1] === '}') {
          return 1
        }
        if (b.intentname[0] === '{' && b.intentname[b.intentname.length - 1] === '}') {
          return -1
        }
        if (nameA < nameB) {
          return -1
        }
        if (nameA > nameB) {
          return 1
        }

        // names must be equal
        return 0
      })
      return vm.intents.filter((intent) => {
        var isFound =
          (intent.intentname.toLowerCase().includes(vm.search.toLowerCase()) ||
            intent.q_val.toLowerCase().includes(vm.search.toLowerCase()) ||
            intent.a_val.toLowerCase().includes(vm.search.toLowerCase())) &&
          intent.context_in === 'facebooklive'
        return isFound
      })
    },
    excludedIntentName: function () {
      var result = []
      var vm = this
      if (vm.allIntents) {
        vm.allIntents.map(function (intent, index) {
          result.push(intent.intentname)
        })
      }
      return result.join(',')
    }
  },
  watch: {
    selectedBot: function (newVal, oldVal) {
      this.getIntent()
    }
  },
  mounted: function () {
    var vm = this

    vm.$store.dispatch('loading')
    vm.getWelcomeMessage(function () {
      vm.getIntent().then(() => {
        vm.$store.dispatch('loading')
      })
    })
    if (
      vm.$store.state.shoptheme.includes(vm.selectedBot.theme) &&
      !['allinonechat'].includes(this.$route.name)
    ) {
      vm.$store.dispatch('loadCategory').then(function () {
        vm.$store.dispatch('loadProducts')
      })
      vm.$store.dispatch('loadCharges')
    }
    vm.$store.dispatch('loadSetting')
  },
  methods: {
    beforeEnter: function (el) {
      el.style.opacity = 0
      // el.style.height = 0;
    },
    enter: function (el, done) {
      var delay = el.dataset.index * 250
      setTimeout(function () {
        Velocity(el, { opacity: 1 }, { complete: done })
      }, delay)
    },
    leave: function (el, done) {
      var delay = el.dataset.index * 250
      setTimeout(function () {
        Velocity(el, { opacity: 0 }, { complete: done })
      }, delay)
    },
    onSaveIntent: function (payload) {
      // console.log(JSON.parse(payload.a_val))
      var vm = this
      vm.isShow = false
      payload.isShow = true
      vm.intents.push(payload)
      vm.allIntents.push(payload)
      vm.intent = {
        intentname: '',
        q_type: 'text',
        a_type: 'json',
        q_val: '',
        a_val: [[]],
        context_in: '',
        context_out: '',
        pageidlist: '',
        userstatus: '',
        usertags: '',
        linenoti_status: false,
        linenoti_text: null,
        starttime: null,
        endtime: null,
        intentstatus: true,
        intentgroup: null
      }
      vm.lastedIntentName = payload.intentname
      vm.isSave = true
      vm.onClose()
      vm.isSave = false
      vm.$swal.fire({
        title:
          vm.$t('conversation') +
          ' "' +
          payload.intentname.replace(/\<|\>/g, '') +
          '" ' +
          vm.$t('added'),
        type: 'success',
        confirmButtonText: vm.$t('Confirm'),
        cancelButtonText: vm.$t('cancel'),
        reverseButtons: true
      })
      this.$emit('getIntent', this.intents)
    },
    copyIntent: function (payload) {
      payload.onCopy().then((result) => {
        payload.isShow = true
        this.intents.push(payload)
        this.allIntents.push(payload)
        var vm = this
        vm.$swal.fire({
          title:
            vm.$t('conversation') +
            ' "' +
            payload.intentname.replace(/\<|\>/g, '') +
            '" ' +
            vm.$t('added'),
          type: 'success',
          confirmButtonText: vm.$t('Confirm'),
          cancelButtonText: vm.$t('cancel'),
          reverseButtons: true
        })
      })
    },
    onClose: function (payload) {
      this.isShow = false
      this.$emit('getIntent', this.intents)
    },
    getIntent: async function () {
      let vm = this
      let params = {
        pageid: vm.selectedBot.pageid,
        sort_by: 'intentname',
        sort_type_available: 'asc'
      }
      try {
        const response = await intentApi.getIntent({ params })
        await handleResponse(response)
        const data = response.data.data
        if (data) {
          let isFoundDefault = false
          vm.allIntents = data
          vm.intents = data
            .map((val) => {
              let intent = val
              intent.isShow = false
              intent.ableToDelete = true
              if (intent.context_in == 'facebooklive') {
                if (intent.intentname == '{default_live}') {
                  intent.ableToDelete = false
                  isFoundDefault = true
                  vm.default_live = intent
                  return false
                } else {
                  return intent
                }
              }
            })
            .filter(Boolean)

          if (!isFoundDefault) {
            vm.default_live = {
              intentname: '{default_live}',
              q_type: 'text',
              a_type: 'json',
              q_val: '{default}',
              a_val: [[]],
              context_in: '',
              context_out: '',
              ableToDelete: false,
              isShow: false,
              pageidlist: '',
              userstatus: '',
              usertags: '',
              linenoti_status: false,
              linenoti_text: null,
              starttime: null,
              endtime: null,
              intentstatus: true
            }
          }
        }
      } catch (error) {
        handleApiError(error)
      }
    },
    deleteIntent: function (index) {
      let vm = this
      vm.$swal
        .fire({
          title: vm.$t('Do you want to delete {name}?', {
            name: vm.filterIntents[index].intentname.replace(/\<|\>/g, '')
          }),
          type: 'warning',
          showCancelButton: true,
          confirmButtonText: vm.$t('Confirm'),
          cancelButtonText: vm.$t('cancel'),
          reverseButtons: true
        })
        .then((result) => {
          if (result.value) {
            let data = {
              id: vm.filterIntents[index].id,
              pageid: vm.selectedBot.pageid
            }
            vm.$store.dispatch('loading')
            api.deleteIntent(data, function (error, response) {
              if (error) {
                console.error(error)
                vm.$store.dispatch('loading')
                return
              }

              $.each(vm.intents, function (intent_index, intent) {
                if (intent.id == data.id) {
                  vm.intents.splice(intent_index, 1)
                  return false
                }
              })

              if (vm.allIntents) {
                var findIndex = vm.allIntents.find(function (el) {
                  return el.id == data.id
                })

                if (findIndex > -1) {
                  vm.allIntents.splice(findIndex, 1)
                }
              }
              vm.$store.dispatch('loading')
              vm.$emit('getIntent', vm.intents)
            })
          }
        })
    },
    addCommentToInbox() {
      if (this.$store.getters.getPackage != 'premium' && this.filterIntents.length >= 10) {
        this.$swal
          .fire({
            html: `<strong class="intentmax"> ${this.$t(
              'if you want to add more reply comment, <br/>please upgrade to premium'
            )}</strong>`,
            confirmButtonText: this.$t('Upgrade now'),
            confirmButtonColor: this.$vuetify.theme.primary
          })
          .then((result) => {
            if (result.value) {
              this.$router.push('Upgrade')
            }
          })
      } else {
        this.isShow = true
      }
    },
    getWelcomeMessage: function (callback) {
      let vm = this
      let data = {
        pageid: vm.selectedBot.pageid
      }

      vm.welcome_message.message = null
      vm.welcome_message.generics = [
        {
          image_url: null,
          title: '',
          subtitle: '',
          buttons: [],

          enable: true
        },
        {
          image_url: null,
          title: '',
          subtitle: '',
          buttons: [],

          enable: false
        },
        {
          image_url: null,
          title: '',
          subtitle: '',
          buttons: [],

          enable: false
        }
      ]
      vm.welcome_message.type = 'message'
      api.getWelcomeMessage(data, function (error, response) {
        if (error) {
          console.error(error)
          return
        }
        if (response.data) {
          vm.welcome_message.type = response.data.type
          vm.welcome_message.message = response.data.message_text ? response.data.message_text : ''

          if (
            response.data.message &&
            typeof response.data.message === 'object' &&
            response.data.message.length > 0
          ) {
            $.each(response.data.message, function (index, val) {
              vm.welcome_message.generics[index] = val
            })
          }

          if (
            response.data.message_quickreplies &&
            response.data.message_quickreplies !== '' &&
            response.data.message_quickreplies != null
          ) {
            vm.welcome_message.quick_reply = response.data.message_quickreplies.split(',')
          } else {
            vm.welcome_message.quick_reply = []
          }
        }
        callback()
      })
    },
    expandAll: function () {
      this.toggleVisibleAll(true)
    },
    collapseAll: function () {
      this.toggleVisibleAll(false)
    },
    toggleVisibleAll(val) {
      var vm = this
      vm.intents = vm.intents.map((intent) => ({ ...intent, isShow: val }))
      vm.default_intent.isShow = val
    },
    onUpdateIntent: function (payload) {
      const vm = this
      const index = vm.intents.findIndex((intent) => {
        return intent.id == payload.id
      })
      if (index != -1) {
        vm.intents[index] = payload
      }
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/view/live/Intent.vue